<template>
  <v-card tile>
    <v-row class="ma-0">
      <v-card-title><h2>Verification email sent</h2></v-card-title>
    </v-row>
    <v-row class="ma-0">
      <v-col cols="8" class="pa-2">
        <v-card-text class="pt-0">
          <p class="subheader">Please check your inbox</p>
          <p>
            An email has been sent to
            <strong>{{ user ? user.email : '' }}</strong>
          </p>
          <p>
            It contains a magic link that will automatically navigate you back
            to this website.
          </p>
        </v-card-text>
      </v-col>
      <v-col cols="4" class="pa-2">
        <v-img
          :src="require('@/assets/images/img-registration-three@3x.png')"
          max-width="293px"
          max-height="342px"
        ></v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8" class="pa-2" justify="center">
        <v-card-actions>
          <v-btn text class="button color--inactive" @click="logout"
            >Logout</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            outlined
            class="button"
            color="primary"
            :loading="loading"
            @click="resendEmail"
            :disabled="this.timeout > 0"
            >{{ resendBtnTitle }}</v-btn
          >
        </v-card-actions>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { auth } from '@/firebaseConfig'
import { mapActions } from 'vuex'
export default {
  params: {
    throttle: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      timeout: this.throttle ?? 0,
      timer: null,
      loading: false,
    }
  },
  created() {
    this.countDownTimer()
  },
  computed: {
    resendBtnTitle() {
      if (this.timeout > 0) {
        return `Resend email (${this.timeout}s)`
      }
      return 'Resend email'
    },
    user() {
      return auth.currentUser
    },
  },
  methods: {
    ...mapActions(['showError', 'showSuccess']),
    countDownTimer() {
      if (this.timeout > 0) {
        setTimeout(() => {
          this.timeout -= 1
          this.countDownTimer()
        }, 1000)
      }
    },
    async resendEmail() {
      try {
        this.loading = true
        await this.user.sendEmailVerification()
        this.timeout = 60
        this.countDownTimer()
        this.showSuccess('Email sent')
      } catch (error) {
        console.error(error)
        this.showError(error.message)
      } finally {
        this.loading = false
      }
    },
    logout() {
      auth
        .signOut()
        .then(() => {
          this.$store.dispatch('clearState')
          this.$router.push({ name: 'login' })
        })
        .catch((err) => {
          this.showError(err)
        })
    },
  },
}
</script>

<style lang="sass" scoped>
.subheader
  @include sectionTitle
</style>
